// El destino de un héroe cautivo (`heroes.captivity`) — español. Se une en
// ./messages.ts.

export const gameHeroesEs = {
  'heroes.captives': 'Héroes que retenes',
  'heroes.taken': 'Tus héroes, cautivos',
  'heroes.heldSince': 'Retenido desde la ticada {n}',
  'heroes.level': 'Nivel {n}',
  'heroes.takenAt': 'Tomado en {q},{r}',
  'heroes.decision': 'Decisión',
  'heroes.payRansom': 'Pagar el rescate',
  'heroes.noRansom': 'Aún no se ha pedido rescate',
  'heroes.captor.title': '¿Qué le ocurre a {name}?',
  'heroes.captor.body': 'Retienes a un héroe de otra casa. Recordará lo que decidas.',
  'heroes.captor.ransomBody': 'Pide oro. Si nadie paga, el héroe solo queda retenido.',
  'heroes.captor.holdBody': 'Retenlo. Un héroe retenido todavía puede escaparse por su cuenta.',
  'heroes.captor.executeBody': 'Acábalo ahora. Una muerte se recuerda como una muerte.',
  'heroes.captor.releaseBody': 'Suéltalo. No se gana nada y no se pierde nada.',
  'heroes.quests': 'Órdenes de los héroes',
  'heroes.noQuests': 'Ningún héroe de tu casa tiene una orden',
  'heroes.giveOrder': 'Dar una orden',
  'heroes.order': 'Orden',
  'heroes.order.slay': 'Matar a {n} enemigos',
  'heroes.order.hunt': 'Cazar a {name}',
  'heroes.order.kind.slay': 'Matar',
  'heroes.order.kind.hunt': 'Cazar',
  'heroes.quest.progress': '{made}/{needed}',
  'heroes.quest.due': 'Vence en la ticada {n}',
  'heroes.quest.active': 'Abierta',
  'heroes.quest.completed': 'Cumplida',
  'heroes.quest.failed': 'Fallida',
  'heroes.quest.dialog.title': '¿Para qué sirve {name}?',
  'heroes.quest.dialog.body':
    'Una orden es un contrato. El héroe cobra cuando se cumple, y se agota sola si no.',
  'heroes.quest.dialog.slayLabel': 'Enemigos a matar',
  'heroes.quest.dialog.give': 'Dar la orden',
  'heroes.quest.dialog.noTargets': 'No se ve ningún héroe enemigo al que cazar',
  'heroes.quest.dialog.cancel': 'Ahora no',
} as const;
